import React, { useEffect, useState } from 'react'
import * as S from './styles'

import { useTranslation } from 'react-i18next'

const CustomPathology = () => {
  const { t } = useTranslation()

  const [title1, setTitle1] = useState('')
  const [title2, setTitle2] = useState('')
  const [text1, setText1] = useState('')
  const [text2, setText2] = useState('')
  const [text3, setText3] = useState('')
  const [text4, setText4] = useState('')
  const [text5, setText5] = useState('')
  const [text6, setText6] = useState('')
  const [text7, setText7] = useState('')
  const [text8, setText8] = useState('')
  const [text9, setText9] = useState('')
  const [text10, setText10] = useState('')
  const [text11, setText11] = useState('')
  const [text12, setText12] = useState('')
  const [text13, setText13] = useState('')
  const [text14, setText14] = useState('')

  useEffect(() => {
    setTitle1(t('titles.pathophysiology'))
    setTitle2(t('titles.histopathology'))
    setText1(t('titles.sickleAnemia'))
    setText2(t('titles.diabetes1'))
    setText3(t('titles.diabetes2'))
    setText4(t('titles.respiratoryDiseases'))
    setText5(t('titles.vascularDiseases'))
    setText6(t('titles.bloodDiseases'))
    setText7(t('titles.tumor'))
    setText8(t('titles.brainDiseases'))
    setText9(t('titles.genitalDiseases'))
    setText10(t('titles.inflammation'))
    setText11(t('titles.lesions'))
    setText12(t('titles.endocrineDiseases'))
    setText13(t('titles.immuneDiseases'))
    setText14(t('titles.boneDiseases'))
  }, [t])

  return (
    <S.CustomPathologyContainer>
      <div>
        <h4>{title1}</h4>
        <ul>
          <li>{text1}</li>
          <li>{text2}</li>
          <li>{text3}</li>
        </ul>
      </div>

      <div>
        <h4>{title2}</h4>
        <ul>
          <li>{text4}</li>
          <li>{text5}</li>
          <li>{text6}</li>
          <li>{text7}</li>
          <li>{text8}</li>
          <li>{text9}</li>
          <li>{text10}</li>
          <li>{text11}</li>
          <li>{text12}</li>
          <li>{text13}</li>
          <li>{text14}</li>
        </ul>
      </div>
    </S.CustomPathologyContainer>
  )
}

export default CustomPathology
